import * as actions from './actionTypes';
import axios from 'axios';

/* Action creaters for starting request. */
export const getAcademicDetailsStart = () => {
  return {
    type: actions.GET_ACADEMIC_DETAILS_START
  }
}

export const getCollegeDetailsStart = () => {
  return {
    type: actions.GET_COLLEGE_DETAILS_START
  }
}

export const getCourseDetailsStart = () => {
  return {
    type: actions.GET_COURSE_DETAILS_START
  }
}

export const getStreamDetailsStart = () => {
  return {
    type: actions.GET_STREAM_DETAILS_START
  }
}

export const getYearAndSemesterDetailsStart = () => {
  return {
    type: actions.GET_YEAR_AND_SEMESTER_DETAILS_START
  }
}

/* Action creators for failed requests. */
export const getAcademicDetailsFail = (error) => {
  return {
    type: actions.GET_ACADEMIC_DETAILS_FAIL,
    error: error
  }
}

export const getCollegeDetailsFail = () => {
  return {
    type: actions.GET_COLLEGE_DETAILS_FAIL
  }
}

export const getCourseDetailsFail = () => {
  return {
    type: actions.GET_COURSE_DETAILS_FAIL
  }
}

export const getStreamDetailsFail = () => {
  return {
    type: actions.GET_STREAM_DETAILS_FAIL
  }
}

export const getYearAndSemesterDetailsFail = () => {
  return {
    type: actions.GET_YEAR_AND_SEMESTER_DETAILS_FAIL
  }
}

/* Action creator for successful requests. */
export const getAcademicDetailsSuccess = (data) => {
  return {
    type: actions.GET_ACADEMIC_DETAILS_SUCCESS,
    data: data
  }
}

export const getCollegeDetailsSuccess = (data) => {
  return {
    type: actions.GET_COLLEGE_DETAILS_SUCCESS,
    data: data
  }
}

export const getCourseDetailsSuccess = (data) => {
  return {
    type: actions.GET_COURSE_DETAILS_SUCCESS,
    data: data
  }
}

export const getStreamDetailsSuccess = (data) => {
  return {
    type: actions.GET_STREAM_DETAILS_SUCCESS,
    data: data
  }
}

export const getYearAndSemesterDetailsSuccess = (data) => {
  return {
    type: actions.GET_YEAR_AND_SEMESTER_DETAILS_SUCCESS,
    data: data
  }
}

/* Action creators to make async requests. */
export const getAcademicDetails = () => {
  return (dispatch) => {
    dispatch(getAcademicDetailsStart());
    axios.get('http://13.234.61.196:2222/getAcademicDetails')
      .then((res) => {
        console.log(res.data.universities);
        dispatch(getAcademicDetailsSuccess(res.data.universities));
      }).catch((e) => {
        console.log(e)
        dispatch(getAcademicDetailsFail());
      });
  }
}

export const getCollegeDetails = (university_id) => {
  return (dispatch) => {
    const reqData = {
      university_id: university_id
    };
    console.log(reqData);
    dispatch(getCollegeDetailsStart());
    axios.get('http://13.234.61.196:2222/getCollegeAccToUniv', {
      params: reqData
    })
      .then((res) => {
        console.log(res.data.colleges);
        dispatch(getCollegeDetailsSuccess(res.data.colleges));
      }).catch((e) => {
        console.log(e)
        dispatch(getCollegeDetailsFail());
      });
  }
}

export const getCourseDetails = (university_id, college_id) => {
  return (dispatch) => {
    const reqData = {
      university_id: university_id,
      //college_id: college_id
      college_id: 2  // To be changed while deploying. Test server doesn't have all records,
                     // so we need to do this to fetch some courses.
    };
    console.log(reqData);
    dispatch(getCourseDetailsStart());
    axios.get('http://13.234.61.196:2222/getCourseAccToCollegeAndUniv', {
      params: reqData
    })
      .then((res) => {
        console.log(res.data);
        dispatch(getCourseDetailsSuccess(res.data.courses));
      }).catch((e) => {
        console.log(e);
        dispatch(getCourseDetailsFail());
      });
  }
}

export const getStreamDetails = (university_id, course_id) => {
  return (dispatch) => {
    const reqData = {
      university_id,
      course_id
    };
    console.log(reqData);
    dispatch(getStreamDetailsStart());
    axios.get('http://13.234.61.196:2222/getYearAndSemList', {
      params: reqData
    })
      .then((res) => {
        console.log(res.data);
        dispatch(getStreamDetailsSuccess(res.data.list));
      }).catch((e) => {
        console.log(e);
        dispatch(getStreamDetailsFail());
      });
  }
}

export const getYearAndSemesterDetails = (course_id) => {
  return (dispatch) => {
    const reqData = {
      course_id
    };
    console.log(reqData);
    dispatch(getYearAndSemesterDetailsStart());
    axios.get('http://13.234.61.196:2222/getYearAccToCourse', {
      params: reqData
    })
      .then((res) => {
        console.log(res.data);
        dispatch(getYearAndSemesterDetailsSuccess(res.data.years));
      }).catch((e) => {
        console.log(e);
        dispatch(getYearAndSemesterDetailsFail());
      });
  }
}
